import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmployeeDocument  {
    _originalTypeClassName = "zERP.BO.EmployeeDocument";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmployeeDocument.translate = translateService;
}
this.Id = null;
this.Name = null;
this.Description = null;
this.Code = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Description:any;
Code:any;
Employee:any;
Contract:any;
File:any;
static setEmployee = ($this, value) => {
var oldValue = $this.Employee;
$this.Employee = value;
if (value != null) {
if (oldValue != null) {
Domain.Employee.removeDocuments(oldValue, $this);
}
Domain.Employee.addDocuments(value, $this);
}
}
static setContract = ($this, value) => {
var oldValue = $this.Contract;
$this.Contract = value;
if (value != null) {
if (oldValue != null) {
Domain.EmployeeContract.removeDocuments(oldValue, $this);
}
Domain.EmployeeContract.addDocuments(value, $this);
}
}
static setFile = ($this, value) => {
var oldValue = $this.File;
$this.File = value;
if (value != null) {
}
}

static GetClassName(): any{return "EmployeeDocument";
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}